import { SkypeGlimpseProps } from './components/SkypeGlimpse';

import { default as skypeStore } from './store/store';
import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { ComponentClass } from 'react';
import { default as addChatTab } from './utils/addChatTabActionCreator';
import shouldOwaInitializeSkype from './utils/shouldOwaInitializeSkype';
import isSkypeInTabsEnabled from './utils/isSkypeInTabsEnabled';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Skype", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const SkypeGlimpse = createLazyComponent(lazyModule, m => m.SkypeGlimpse);

export const lazyUpdateIsGlimpseOpen = new LazyAction(lazyModule, m => m.updateIsGlimpseOpen);

export const lazyShouldShowUnreadConversationCount = new LazyImport(
    lazyModule,
    m => m.shouldShowUnreadConversationCount
);

let lazyBeginSkypeInitialization = new LazyAction(lazyModule, m => m.beginSkypeInitialization);
let lazyCreateOnSwcReadyEvent = new LazyAction(lazyModule, m => m.createOnSwcReadyEvent);
export const lazyOnNotificationReceived = new LazyAction(lazyModule, m => m.onNotificationReceived);
export const lazyOnHideNotificationReceived = new LazyAction(
    lazyModule,
    m => m.onHideNotificationReceived
);

export { ComponentClass, SkypeGlimpseProps, skypeStore, addChatTab, isSkypeInTabsEnabled };

runAfterInitialRender(() => {
    if (shouldOwaInitializeSkype()) {
        lazyBeginSkypeInitialization.importAndExecute();
    }

    // Even if OWA is not responsbile for initializing Skype,
    // Still need listen to SWC ready events and try to intitialize notification settings
    lazyCreateOnSwcReadyEvent.importAndExecute();
});
